module.exports = __webpack_public_path__ + "assets/img/sheild.4eac1cb0.svg";